import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { LOAN_PRODUCTS } from "@/lib/loanProducts";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2 } from "lucide-react";

export default function Products() {
  return (
    <PublicLayout>
      <section className="border-b border-[#E5E2DE] bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="mb-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#E87722]">Loan products</div>
            <h1 className="font-heading text-4xl font-bold text-ink sm:text-5xl lg:text-6xl">
              Built for the lives <span className="text-[#5B2C82]">Zimbabweans actually live.</span>
            </h1>
            <p className="mt-5 text-lg text-ink-soft">
              Six purpose-built products, each calibrated for a specific kind of customer.
              Your application is routed automatically to the right one.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="space-y-10">
            {LOAN_PRODUCTS.map((p, i) => (
              <div
                key={p.key}
                data-testid={`product-row-${p.key}`}
                className="grid gap-8 rounded-2xl border border-[#E5E2DE] bg-white p-6 lg:grid-cols-12 lg:p-10"
              >
                <div className="lg:col-span-7">
                  <div className="mb-3 flex flex-wrap items-center gap-3">
                    <span className="text-xs font-semibold uppercase tracking-[0.15em] text-ink-muted">
                      Product {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h2 className="font-heading text-2xl font-semibold text-ink sm:text-3xl">{p.title}</h2>
                  <p className="mt-1 text-base font-medium text-[#E87722]">{p.tagline}</p>
                  <p className="mt-4 max-w-xl text-base leading-relaxed text-ink-soft">{p.description}</p>

                  {p.heroImage && (
                    <img
                      src={p.heroImage}
                      alt={p.title}
                      className="mt-5 aspect-[16/9] w-full rounded-xl object-cover"
                    />
                  )}

                  <div className="mt-6 grid grid-cols-3 gap-4 border-t border-[#E5E2DE] pt-5">
                    <div>
                      <div className="text-xs uppercase tracking-wider text-ink-muted">Amount</div>
                      <div className="mt-1 font-heading text-sm font-semibold text-ink">
                        ${p.minAmount.toLocaleString()} – ${p.maxAmount.toLocaleString()}
                      </div>
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-wider text-ink-muted">Term</div>
                      <div className="mt-1 font-heading text-sm font-semibold text-ink">{p.termRange}</div>
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-wider text-ink-muted">Rate</div>
                      <div className="mt-1 font-heading text-sm font-semibold text-ink">{p.rateRange}</div>
                    </div>
                  </div>
                </div>

                <div className="rounded-xl bg-[#F9F6F0] p-6 lg:col-span-5">
                  <div className="text-xs font-semibold uppercase tracking-[0.15em] text-[#5B2C82]">What you'll need</div>
                  <ul className="mt-4 space-y-2">
                    {p.eligibility.map((e) => (
                      <li key={e} className="flex items-start gap-2 text-sm text-ink">
                        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-[#E87722]" />
                        <span>{e}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/apply" state={{ product: p.key }}>
                    <Button
                      className="mt-6 w-full bg-[#5B2C82] text-white hover:bg-[#46225f]"
                      data-testid={`product-apply-${p.key}`}
                    >
                      Apply for this loan <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
